<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    @if (isDataLoad) {
      <div [formGroup]="form1" class="forms w-100 d-block">
        <div class="row m-0">
          <div class="col-lg-12">
            @if (formAlert) {
              <div class="w-100 mb-3">
                <div class="w-100"
                  style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                  <p><b>{{formAlert}}</b></p>
                </div>
              </div>
            }
          </div>
          <div class="col-lg-6">
            <span class="p-float-label required-field w-100 mb-3">
              <p-dropdown class="w-100" [options]="workOrderTypes" formControlName="workOrderType" optionLabel="name"
              optionValue="value" placeholder="" ></p-dropdown>
              <label for="workOrderType">Type</label>
            </span>
          </div>
          <div class="col-lg-6"></div>
          <div class="col-lg-12">
            <span class="p-float-label required-field w-100 mb-3">
              <input id="reservationId" value="{{reservation?.guestProfile?.lastName}} {{reservation?.checkInDate | date}} - {{reservation?.checkOutDate | date}}" type="text" placeholder="Reservation" readonly="true" pInputText>
              <label for="reservationId">Reservation</label>
            </span>
          </div>
          <div class="col-lg-6">
            <span class="p-float-label w-100 mb-3">
              <p-dropdown class="w-100" [options]="workOrderStatuses" formControlName="workOrderStatus" optionLabel="name"
              optionValue="value" placeholder="Status"></p-dropdown>
              <label for="workOrderStatus">Status</label>
              @for (validation of validationMessages.workOrderStatus; track validation) {
                <span>
                  @if (form1.get('workOrderStatus').hasError(validation.type) && (form1.get('workOrderStatus').dirty || form1.get('workOrderStatus').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div class="col-lg-6"></div>
          <div class="col-lg-6">
            <span class="p-float-label w-100 mb-3">
              <p-dropdown class="w-100" [options]="properties" formControlName="shortTermRentalId" readonly="true" optionLabel="propertyCode"
              optionValue="shortTermRentalId" placeholder="Properties"></p-dropdown>
              <label for="shortTermRentalId">Properties</label>
              @for (validation of validationMessages.shortTermRentalId; track validation) {
                <span>
                  @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div formGroupName="workOrderHousekeeping" class="floating-form col-lg-12">
            <div class="col-lg-6">
              <span class="p-float-label w-100 mb-3">
                <p-calendar formControlName="scheduledServiceDate" [defaultDate]="checkInMinDate" selectOtherMonths="true" [minDate]="checkInMinDate" [maxDate]="checkInMaxDate" id="scheduledServiceDate" (onValueChange)="scheduledServiceDate($event)" [showTime]="false">
                </p-calendar>
                <label for="scheduledServiceDate">Scheduled Date</label>
                @for (validation of validationMessages.scheduledServiceDate; track validation) {
                  <span>
                    @if (form1.get('workOrderHousekeeping.scheduledServiceDate').hasError(validation.type) && (form1.get('workOrderHousekeeping.scheduledServiceDate').dirty || form1.get('workOrderHousekeeping.scheduledServiceDate').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-6">
              <span class="p-float-label w-100 mb-3">
                <p-calendar formControlName="scheduledServiceDateTimeStart" id="scheduledServiceDateTimeStart" (onValueChange)="scheduledServiceDateTimeStart($event)" [timeOnly]="true" [hourFormat]="12" inputId="calendar-12h">
                </p-calendar>
                <label for="scheduledServiceDateTimeStart">Scheduled Time From</label>
                @for (validation of validationMessages.scheduledServiceDateTimeStart; track validation) {
                  <span>
                    @if (form1.get('workOrderHousekeeping.scheduledServiceDateTimeStart').hasError(validation.type) && (form1.get('workOrderHousekeeping.scheduledServiceDateTimeStart').dirty || form1.get('workOrderHousekeeping.scheduledServiceDateTimeStart').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-6">
              <span class="p-float-label w-100 mb-3">
                <p-calendar formControlName="scheduledServiceDateTimeStop" id="scheduledServiceDateTimeStop" (onValueChange)="scheduledServiceDateTimeStop($event)" [timeOnly]="true" [hourFormat]="12" inputId="calendar-12h">
                </p-calendar>
                <label for="airportArrivalDate">Scheduled Time To</label>
                @for (validation of validationMessages.airportArrivalDate; track validation) {
                  <span>
                    @if (form1.get('workOrderHousekeeping.scheduledServiceDateTimeStop').hasError(validation.type) && (form1.get('workOrderHousekeeping.scheduledServiceDateTimeStop').dirty || form1.get('workOrderHousekeeping.scheduledServiceDateTimeStop').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-6">
              <span class="p-float-label w-100 mb-3">
                <p-dropdown class="w-100" [options]="housekeepingTypes" formControlName="housekeepingType" optionLabel="name"
                optionValue="value" placeholder=""></p-dropdown>
                <label for="housekeepingType">Housekeeping Type</label>
                @for (validation of validationMessages.housekeepingType; track validation) {
                  <span>
                    @if (form1.get('workOrderHousekeeping.housekeepingType').hasError(validation.type) && (form1.get('workOrderHousekeeping.housekeepingType').dirty || form1.get('workOrderHousekeeping.housekeepingType').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-6">
              <span class="p-float-label w-100 mb-3">
                <p-dropdown class="w-100" [options]="salesManList" formControlName="assignedToUserId" optionLabel="name"
                optionValue="value" placeholder=""></p-dropdown>
                <label for="assignedToUserId">Housekeeper</label>
                @for (validation of validationMessages.creditSaleTo; track validation) {
                  <span>
                    @if (form1.get('workOrderHousekeeping.assignedToUserId').hasError(validation.type) && (form1.get('workOrderHousekeeping.assignedToUserId').dirty || form1.get('workOrderHousekeeping.assignedToUserId').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <textarea formControlName="description" id="description" [rows]="1" placeholder="Description of Service (shows to guest)" pInputTextarea></textarea>
                <label for="description">Description of Service (shows to guest)</label>
                @for (validation of validationMessages.description; track validation) {
                  <span>
                    @if (form1.get('workOrderHousekeeping.description').hasError(validation.type) && (form1.get('workOrderHousekeeping.description').dirty || form1.get('workOrderHousekeeping.description').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <textarea formControlName="technicianNotes" id="destechnicianNotescription" [rows]="1" placeholder="Notes to Housekeeper" pInputTextarea></textarea>
                <label for="technicianNotes">Notes to Housekeeper</label>
                @for (validation of validationMessages.technicianNotes; track validation) {
                  <span>
                    @if (form1.get('workOrderHousekeeping.technicianNotes').hasError(validation.type) && (form1.get('workOrderHousekeeping.technicianNotes').dirty || form1.get('workOrderHousekeeping.technicianNotes').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <textarea formControlName="privateNotes" id="privateNotes" [rows]="1" placeholder="Notes to Ops (shows to manager)" pInputTextarea></textarea>
                <label for="privateNotes">Notes to Ops (shows to manager)</label>
                @for (validation of validationMessages.privateNotes; track validation) {
                  <span>
                    @if (form1.get('workOrderHousekeeping.privateNotes').hasError(validation.type) && (form1.get('workOrderHousekeeping.privateNotes').dirty || form1.get('workOrderHousekeeping.privateNotes').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <textarea formControlName="guestNotes" id="guestNotes" [rows]="1" placeholder="Notes from Guest" pInputTextarea></textarea>
                <label for="guestNotes">Notes from Guest</label>
                @for (validation of validationMessages.guestNotes; track validation) {
                  <span>
                    @if (form1.get('workOrderHousekeeping.guestNotes').hasError(validation.type) && (form1.get('workOrderHousekeeping.guestNotes').dirty || form1.get('workOrderHousekeeping.guestNotes').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <textarea formControlName="changeLog" id="changeLog" [rows]="1" placeholder="Change Log" pInputTextarea></textarea>
              <label for="changeLog">Change Log</label>
              @for (validation of validationMessages.changeLog; track validation) {
                <span>
                  @if (form1.get('changeLog').hasError(validation.type) && (form1.get('changeLog').dirty || form1.get('changeLog').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <!-- <div class="col-lg-6">
          <label for="workOrderDate">WorkOrder Date</label>
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="workOrderDate" inputId="workOrderDate" placeholder="WorkOrder Date">
            </p-calendar>
            <span *ngFor="let validation of validationMessages.workOrderDate">
              <small class="p-invalid"
                *ngIf="form1.get('workOrderDate').hasError(validation.type) && (form1.get('workOrderDate').dirty || form1.get('workOrderDate').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div>
        <div class="col-lg-6">
          <label for="name">Property</label>
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="Property"></p-dropdown>
            <label for="Property">Property</label>
            <span *ngFor="let validation of validationMessages.status">
              <small class="p-invalid"
                *ngIf="form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div>
        <div class="col-lg-12">
          <label for="name">Scheduled Time</label>
        </div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="scheduledHourStart"></p-dropdown>
            <label for="scheduledHourStart">scheduledHourStart</label>
            <span *ngFor="let validation of validationMessages.status">
              <small class="p-invalid"
                *ngIf="form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="scheduledMinuteStart"></p-dropdown>
            <label for="scheduledMinuteStart">scheduledMinuteStart</label>
            <span *ngFor="let validation of validationMessages.status">
              <small class="p-invalid"
                *ngIf="form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="scheduledAmPmStart"></p-dropdown>
            <label for="scheduledAmPmStart">scheduledAmPmStart</label>
            <span *ngFor="let validation of validationMessages.status">
              <small class="p-invalid"
                *ngIf="form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="scheduledHourEnd"></p-dropdown>
            <label for="scheduledHourEnd">scheduledHourEnd</label>
            <span *ngFor="let validation of validationMessages.status">
              <small class="p-invalid"
                *ngIf="form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="scheduledMinuteEnd"></p-dropdown>
            <label for="scheduledMinuteEnd">scheduledMinuteEnd</label>
            <span *ngFor="let validation of validationMessages.status">
              <small class="p-invalid"
                *ngIf="form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="scheduledAmPmEnd"></p-dropdown>
            <label for="scheduledAmPmEnd">scheduledAmPmEnd</label>
            <span *ngFor="let validation of validationMessages.status">
              <small class="p-invalid"
                *ngIf="form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div>
        <div class="col-lg-6">
          <label for="name">Type</label>
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="Type"></p-dropdown>
            <label for="Type">Type</label>
            <span *ngFor="let validation of validationMessages.status">
              <small class="p-invalid"
                *ngIf="form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div>
        <div class="col-lg-6">
          <label for="name">Housekeeper</label>
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="Housekeeper"></p-dropdown>
            <label for="Housekeeper">Housekeeper</label>
            <span *ngFor="let validation of validationMessages.status">
              <small class="p-invalid"
                *ngIf="form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div>
        <div class="col-lg-12">
          <label for="description">Description of Service</label>
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="description" id="description" [rows]="1" placeholder="Description of Service" pInputTextarea></textarea>
            <span *ngFor="let validation of validationMessages.description">
              <small class="p-invalid"
                *ngIf="form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div>
        <div class="col-lg-12">
          <label for="description">Notes to Housekeeper</label>
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="description" id="description" [rows]="1" placeholder="Notes to Housekeeper" pInputTextarea></textarea>
            <span *ngFor="let validation of validationMessages.description">
              <small class="p-invalid"
                *ngIf="form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div>
        <div class="col-lg-12">
          <label for="description">Notes to Ops</label>
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="description" id="description" [rows]="1" placeholder="Notes to Ops" pInputTextarea></textarea>
            <span *ngFor="let validation of validationMessages.description">
              <small class="p-invalid"
                *ngIf="form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div>
        <div class="col-lg-12">
          <label for="description">Notes from Guest</label>
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="description" id="description" [rows]="1" placeholder="Notes from Guest" pInputTextarea></textarea>
            <span *ngFor="let validation of validationMessages.description">
              <small class="p-invalid"
                *ngIf="form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div>
        <div class="col-lg-12">
          <label for="isWorkOrder">WorkOrder Options</label>
          <div class="flex align-items-center">
            <p-checkbox [formControl]="form1.controls['isWorkOrder']" inputId="isWorkOrder" [binary]="true">
            </p-checkbox>
            <span class="workOrder-nm">Is WorkOrder?</span>
          </div>
          <span *ngFor="let validation of validationMessages.isWorkOrder">
            <small class="p-invalid"
              *ngIf="form1.get('isWorkOrder').hasError(validation.type) && (form1.get('isWorkOrder').dirty || form1.get('isWorkOrder').touched)">{{validation.message}}
            </small>
          </span>
        </div> -->
      </div>
    </div>
  }
  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            <!-- <button pButton *ngIf="workOrderId" class="btn-delete p-button-outlined p-button-danger"
          (click)="onFormDelete()">Delete Work Order</button> -->
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          @if (!workOrderId) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add Work Order</button>
          }

          @if (workOrderId) {
            <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Work Order</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>